import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { I18nProvider } from './i18n.jsx'

createRoot(document.getElementById('root')).render(<StrictMode><I18nProvider><App /></I18nProvider></StrictMode>)
